import { gql } from '@apollo/client'

/**
 * BE: Kiosk API - Invalidate Kiosk Widgets
 */
export const INVALIDATE_KIOSK_WIDGETS_MUTATION = gql`
  mutation InvalidateKioskWidgets($input: InvalidateWidgetsInput!) {
    kioskInvalidateWidgets(input: $input) {
      success
      invalidatedCount
      errors {
        widgetId
        widgetName
        error
      }
    }
  }
`
